import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';

const groupKeyToLabelMapping = {
  COUNTRY_TAX_TYPE: 'Jurisdiction',
  COMPANY_CODE: 'Company Code',
  COUNTRY_NAME: 'Country',
};

export const getGroupedFileLabel = (groupField, displayedScenarioParams) => {
  const currencyLabel = displayedScenarioParams.find(({ label }) => label === 'Currency').value || '';
  const groupLabel = groupKeyToLabelMapping[groupField] || groupField;
  const baseScenarioLabel = displayedScenarioParams.find(({ label }) => label === 'Scenario').value || '';
  const groupDataLabel = `By_${groupLabel}`;

  return `${baseScenarioLabel}_${currencyLabel}_${groupDataLabel}`.replace(/ /g, '_');
};

export const getNonGroupedFileLabel = displayedScenarioParams => displayedScenarioParams
  .map(({ value }) => value)
  .filter(val => val)
  .join('_')
  .replace(/ /g, '_');

export default async ({
  fetchDetails,
  displayedReportFields,
  isComparing,
  reportsData,

  hideDecimals,
  negativeMinus,
  shouldDisplayZero,
  environmentSuffix,

  displayedScenarioParams,
  groupField,
  totalColumn,
}) => {
  const result = await fetchDetails();
  if (result.isError) {
    return;
  }
  const { baseDetailsData, compareDetailsData } = result.data;

  const fileNameParamsLabel = groupField
    ? getGroupedFileLabel(groupField, displayedScenarioParams)
    : getNonGroupedFileLabel(displayedScenarioParams);

  const fileName = `TLS_Scenario_Reports_${fileNameParamsLabel}${environmentSuffix}`;

  const sheetData = [{
    name: 'Scenario Report',
    type: SheetExportTypes.SCENARIO_REPORT,
    reportsData,
    isComparing,
    displayedScenarioParams,
    detailsData: {
      baseDetailsData, compareDetailsData,
    },
    displayedReportFields,
    options: {
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
    },
    totalColumn,
  }];

  return xlsxExport({
    sheetData,
    metadata: {
      fileName,
    },
  });
};
